import { useEffect, useRef, useState } from "react";

export default function OddsCell({ price, side, onPick, testid }) {
  const prev = useRef(price);
  const [flash, setFlash] = useState("");
  useEffect(() => {
    if (prev.current && price && price !== prev.current) {
      setFlash(price > prev.current ? "ring-2 ring-emerald-400" : "ring-2 ring-red-400");
      const t = setTimeout(() => setFlash(""), 1200);
      prev.current = price;
      return () => clearTimeout(t);
    }
    prev.current = price;
  }, [price]);

  const base =
    side === "back"
      ? "bg-gradient-to-b from-[#8fcaf3] to-[#72BBEF] hover:brightness-110"
      : "bg-gradient-to-b from-[#fbbccb] to-[#FAA9BA] hover:brightness-110";
  if (!price)
    return (
      <div className="h-11 w-full rounded-sm bg-zinc-800/70 grid place-items-center text-zinc-500 text-xs font-mono-stat">
        –
      </div>
    );
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onPick?.();
      }}
      className={`${base} ${flash} h-11 w-full rounded-sm text-black transition-[filter,box-shadow,transform] duration-200 active:scale-95 leading-tight shadow-inner`}
    >
      <div className={`font-mono-stat font-bold px-0.5 ${price >= 100 ? "text-[11px] sm:text-sm" : "text-sm"}`}>{price.toFixed(2)}</div>
      <div className="text-[9px] opacity-70">{side === "back" ? "Back" : "Lay"}</div>
    </button>
  );
}
